<script setup>
import { computed } from 'vue'
import { getPackages } from '~/data/packages'


const props = defineProps({
  title: {
    type: String,
    default: 'Unsere Fotobox Pakete'
  },
  subtitle: {
    type: String,
    default: 'Wählen Sie das passende Paket für Ihre Veranstaltung - für jedes Budget die perfekte Lösung.'
  }, 
  contactUrl: {
    type: String,
    default: '#anfrage'
  },
  locationName: {
    type: String,
    default: ''
  },
  showPrices: {
    type: Boolean,
    default: true
  }
})

const packages = getPackages()
const { scrollToInquiryForm } = useScrollToInquiryForm()
const selectedPackage = useSelectedPackage()

const selectPackage = (packageTitle) => {
  selectedPackage.value = packageTitle
  scrollToInquiryForm()
}

// Wenn ein Standortname übergeben wurde, füge ihn zum Titel hinzu
const displayTitle = computed(() => {
  if (props.locationName) {
    return `Unsere Fotobox Pakete für ${props.locationName}`
  }
  return props.title
})
</script>

<template>
  <section id="pakete" class="py-16 bg-white">
    <div class="container mx-auto px-4">
      <div class="text-center mb-12">
        <h2 class="heading-2 mb-4">{{ displayTitle }}</h2>
        <p class="text-lg text-gray-600 max-w-3xl mx-auto">{{ subtitle }}</p>
      </div>
      
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div v-for="(pkg, index) in packages" :key="index" 
             class="border border-gray-200 rounded-lg overflow-hidden transition-all hover:shadow-lg"
             :class="{'ring-2 ring-primary': pkg.isPopular}">
          <div v-if="pkg.isPopular" class="bg-primary text-white py-2 px-4 text-center font-medium">
            Beliebteste Wahl
          </div>
          <div class="p-6">
            <h3 class="text-2xl font-semibold mb-2">{{ pkg.title }}</h3>
            <p class="text-gray-600 mb-4">{{ pkg.description }}</p>
            <ul class="space-y-3 mb-6">
              <li v-for="(feature, i) in pkg.features" :key="i" class="flex items-start">
                <span class="text-green-500 mr-2">✓</span>
                <span>{{ feature }}</span>
              </li>
            </ul>
            <p v-if="showPrices" class="text-2xl font-bold mb-4 text-center font-medium">{{ pkg.price }}</p>
            <button
              type="button"
              @click="selectPackage(pkg.title)"
              class="mt-7 inline-flex h-14 w-full items-center justify-center rounded-lg border border-pink-700 px-5 text-center font-sans text-base font-medium transition focus:outline-none focus:ring-2 focus:ring-pink-700 focus:ring-offset-2"
              :class="pkg.isPopular ? 'bg-pink-700 text-white shadow-[0_10px_24px_rgba(219,39,119,0.24)] hover:bg-pink-700' : 'bg-white text-pink-700 hover:bg-pink-50'"
            >
              Individuelles Angebot anfordern
            </button>
          </div>
        </div>
      </div>
      
      <div class="mt-12 text-center max-w-2xl mx-auto">
        <p class="text-gray-600">Jedes Paket kann individuell angepasst werden. Kontaktieren Sie uns für ein maßgeschneidertes Angebot, das perfekt zu Ihren Bedürfnissen und Ihrem Budget passt.</p>
      </div>
    </div>
  </section>
</template>
